<template>
	<router-view />
	<BetaButton
		v-if="enableBeta"
	/>
	<ReportButton
		v-if="enableReport"
		:language="locale"
	/>
	<AgentButton
		v-if="enableAgent"
		:language="locale"
	/>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useLocale } from '@deepidoo/deesplay/composables';

import AgentButton from './agent/components/agentButton/AgentButton.vue';
import BetaButton from './beta/components/betaButton/BetaButton.vue';
import ReportButton from './report/components/reportButton/ReportButton.vue';

const { locale } = useLocale();

const enableBeta = computed(() => {
	return import.meta.env.VITE_ENABLE_BETA === 'true';
});

const enableReport = computed(() => {
	return import.meta.env.VITE_ENABLE_REPORT === 'true';
});

const enableAgent = computed(() => {
	return import.meta.env.VITE_ENABLE_AGENT === 'true';
});
</script>
